import { render, staticRenderFns } from "./testVaccinationInfo.vue?vue&type=template&id=0b0eb37c"
import script from "./testVaccinationInfo.vue?vue&type=script&lang=js"
export * from "./testVaccinationInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b0eb37c')) {
      api.createRecord('0b0eb37c', component.options)
    } else {
      api.reload('0b0eb37c', component.options)
    }
    module.hot.accept("./testVaccinationInfo.vue?vue&type=template&id=0b0eb37c", function () {
      api.rerender('0b0eb37c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/testVaccinationInfo.vue"
export default component.exports